var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToBeEspecial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 417.667,
    height: 41.454,
    viewBox: "0 0 417.667 41.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_93",
    "data-name": "Rect\\xE1ngulo 93",
    width: 117.676,
    height: 41.454,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_99",
    "data-name": "Rect\\xE1ngulo 99",
    width: 262.694,
    height: 41.454,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_627",
    "data-name": "Grupo 627",
    transform: "translate(-901.162 -6264.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_621",
    "data-name": "Grupo 621",
    transform: "translate(901.162 6264.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_616",
    "data-name": "Grupo 616",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_560",
    "data-name": "Trazado 560",
    d: "M8.957,0H.073L0,31.093c-.018,6.679,4.211,10.345,9.96,10.361a32.5,32.5,0,0,0,7.063-1.227v-5.61a31.006,31.006,0,0,1-4.951-.343c-1.911-.5-3.192-1.706-3.183-4.666L8.918,16.8l8.536.02.018-6.214-8.536-.02Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_561",
    "data-name": "Trazado 561",
    d: "M88.693,19.285a9.051,9.051,0,0,0,7.09-8.977C95.8,4,90.2.071,81.207.048L62.4,0l-.105,40.94H81.745c9.463.026,15.432-4.282,15.448-11.291a9.983,9.983,0,0,0-8.5-10.363M71.609,7.557l9.112.023c3.5-.048,5.6,1.593,5.6,4.4-.007,2.861-2.116,4.55-5.619,4.541L71.586,16.5ZM80.654,33.4l-9.112-.023.026-9.7,9.111.023c4.321-.046,7.005,1.772,7,4.75-.009,3.154-2.7,4.96-7.024,4.949",
    transform: "translate(-37.038 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_562",
    "data-name": "Trazado 562",
    d: "M175.942,24.184l19.668.05.018-7.644-19.667-.051.023-8.872,21.884.057L197.888,0H166.676V40.948h31.751l.018-7.658-22.528-.057Z",
    transform: "translate(-99.102 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_563",
    "data-name": "Trazado 563",
    d: "M271.129,78.251a4.865,4.865,0,1,0,4.853,4.89,4.785,4.785,0,0,0-4.853-4.89m-.021,8.785a3.931,3.931,0,1,1,3.9-3.9,3.855,3.855,0,0,1-3.9,3.9",
    transform: "translate(-158.307 -46.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_564",
    "data-name": "Trazado 564",
    d: "M277.77,85.895c0-.9-.729-1.481-1.822-1.484L273.88,84.4l-.012,4.466.973,0,0-1.432.729,0,1.258,1.436,1.168,0-1.382-1.533a1.5,1.5,0,0,0,1.152-1.453m-1.831.674-1.092,0,0-1.284,1.092,0c.506,0,.846.246.845.632s-.341.654-.848.652",
    transform: "translate(-162.836 -50.185)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_631",
    "data-name": "Grupo 631",
    transform: "translate(1056.135 6264.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_630",
    "data-name": "Grupo 630",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_586",
    "data-name": "Trazado 586",
    d: "M16.145,41.294a22.432,22.432,0,0,1-8.674-1.6A26.615,26.615,0,0,1,0,34.88l1.946-2.232A28.422,28.422,0,0,0,5.237,35.31,18.3,18.3,0,0,0,12.2,38.23a21.212,21.212,0,0,0,4.123.373A13.465,13.465,0,0,0,20.44,38a9.748,9.748,0,0,0,3.207-1.661,7.675,7.675,0,0,0,2.061-2.517,6.9,6.9,0,0,0,.745-3.18v-.113a7.933,7.933,0,0,0-.486-2.864,5.513,5.513,0,0,0-1.776-2.291,13.018,13.018,0,0,0-3.463-1.861A35.98,35.98,0,0,0,15.116,22a38.74,38.74,0,0,1-6.185-1.747A15.23,15.23,0,0,1,4.723,17.9a8.058,8.058,0,0,1-2.375-3.12A10.393,10.393,0,0,1,1.6,10.719V10.6a9.033,9.033,0,0,1,.973-4.151A10.514,10.514,0,0,1,5.267,3.1,12.722,12.722,0,0,1,9.332.869a15.893,15.893,0,0,1,5.152-.8,21.28,21.28,0,0,1,7.53,1.2,22.561,22.561,0,0,1,6.214,3.665L26.337,7.283a18.451,18.451,0,0,0-5.754-3.493A18.384,18.384,0,0,0,14.371,2.76a12.69,12.69,0,0,0-4.036.6A9.939,9.939,0,0,0,7.241,4.992,7.175,7.175,0,0,0,5.267,7.4a6.42,6.42,0,0,0-.688,2.92v.115a8.086,8.086,0,0,0,.488,2.89A5.619,5.619,0,0,0,6.842,15.67a12.619,12.619,0,0,0,3.577,1.921,40.981,40.981,0,0,0,5.84,1.6q6.986,1.434,10.078,4.036a8.706,8.706,0,0,1,3.093,7.015v.115a9.922,9.922,0,0,1-1,4.438,10.366,10.366,0,0,1-2.749,3.465,12.932,12.932,0,0,1-4.18,2.232,17.03,17.03,0,0,1-5.354.8",
    transform: "translate(0 0.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_587",
    "data-name": "Trazado 587",
    d: "M25.262.412H39.806a20.664,20.664,0,0,1,6.042.831,14.008,14.008,0,0,1,4.694,2.405,10.909,10.909,0,0,1,3.063,3.835,11.833,11.833,0,0,1,1.088,5.182v.115a11.494,11.494,0,0,1-4.668,9.562,15.1,15.1,0,0,1-4.981,2.405,21.885,21.885,0,0,1-5.984.8H28.241V40.493H25.262ZM39.233,22.857a17.648,17.648,0,0,0,5.1-.69,11.612,11.612,0,0,0,3.921-1.987A9.188,9.188,0,0,0,50.8,17.042a9.054,9.054,0,0,0,.916-4.09v-.117A9.549,9.549,0,0,0,50.829,8.6a8.346,8.346,0,0,0-2.49-3.023A11.539,11.539,0,0,0,44.5,3.737a18.054,18.054,0,0,0-4.924-.631H28.241V22.857Z",
    transform: "translate(16.82 0.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_588",
    "data-name": "Trazado 588",
    d: "M49.941.412H78.455V3.1H52.92v15.86H75.88v2.69H52.92V37.8H78.742v2.692h-28.8Z",
    transform: "translate(33.252 0.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_589",
    "data-name": "Trazado 589",
    d: "M93.55,41.454a19.651,19.651,0,0,1-7.959-1.6,19.443,19.443,0,0,1-6.327-4.381,19.856,19.856,0,0,1-4.151-6.555,21.817,21.817,0,0,1-1.489-8.073v-.115a21.314,21.314,0,0,1,1.518-8.016A21.008,21.008,0,0,1,79.32,6.1,19.4,19.4,0,0,1,93.663,0,23.612,23.612,0,0,1,98.53.46a18.824,18.824,0,0,1,4.036,1.316,21.11,21.11,0,0,1,3.493,2.032,33.676,33.676,0,0,1,3.178,2.605l-2.119,2.176a32.917,32.917,0,0,0-2.749-2.349,17.3,17.3,0,0,0-3.063-1.859,18.064,18.064,0,0,0-3.55-1.231,17.785,17.785,0,0,0-4.151-.46A16.246,16.246,0,0,0,81.554,7.874a17.946,17.946,0,0,0-3.55,5.7,18.983,18.983,0,0,0-1.288,7.041v.115A18.8,18.8,0,0,0,78.034,27.8a18.238,18.238,0,0,0,3.577,5.725,16.6,16.6,0,0,0,5.354,3.836,16.03,16.03,0,0,0,6.7,1.4,16.72,16.72,0,0,0,7.558-1.6,24.26,24.26,0,0,0,6.244-4.638l2,1.946a37.707,37.707,0,0,1-3.292,2.835,20.542,20.542,0,0,1-3.608,2.2,20.2,20.2,0,0,1-4.15,1.431,21.679,21.679,0,0,1-4.868.515",
    transform: "translate(49.02 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_98",
    "data-name": "Rect\\xE1ngulo 98",
    width: 2.977,
    height: 40.081,
    transform: "translate(169.939 0.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_590",
    "data-name": "Trazado 590",
    d: "M129.514.24h2.862l18.666,40.368h-3.263l-5.1-11.224H119.036l-5.1,11.224h-3.09Zm11.909,26.453L130.886,3.505,120.293,26.693Z",
    transform: "translate(73.806 0.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_591",
    "data-name": "Trazado 591",
    d: "M141.781.412h2.978V37.8h23.533v2.692H141.781Z",
    transform: "translate(94.402 0.275)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToBeEspecial);
export default __webpack_public_path__ + "static/media/toBeEspecial.bc7d46243449faf34801552cff91ee48.svg";
export { ForwardRef as ReactComponent };